import { NavLink } from "react-router-dom";

import { CopyModalContext } from "../../../../../CopyContext";

import MarketCap from "@components/pages/Markets/components/Cards/components/MarketCap";
import { CopytradeButton } from "./components";

import avatarDefault from "@assets/images/default-avatar.svg";
import { ReactComponent as StarIcon } from "@assets/images/icons/star.svg";

import "./CopytraderCard.sass";
import { useContext } from "react";

export const CopytraderCard = ({
  chartData,
  name,
  leverage,
  pnlPercent,
  pnlValue,
  copyTraders,
  maxCopyTraders,
  aum,
  daysLeading,
  isStarred,
}) => {
  const { setIsModalOpen, setSelectedTrader } = useContext(CopyModalContext);

  const isCardDisabled = copyTraders === maxCopyTraders ? true : false;

  const marketCapData = {
    chartData,
    width: 158,
    height: 48,
  };

  const handleCopyClick = (e) => {
    e.preventDefault(); // STOPS the <NavLink> from changing the page!
    if (isCardDisabled) return;

    setSelectedTrader(name); // Sets the modal title to "C1ltra" or "TraderX"
    setIsModalOpen(true); // Opens the modal
  };

  return (
    <NavLink
      to={`/copytrader-profile/${name}`}
      className={`copytrader-card ${
        isCardDisabled ? "copytrader-card--disabled" : ""
      }`}
    >
      <div className="copytrader-card__profile">
        <img
          src={avatarDefault}
          className="copytrader-card__profile-photo"
          alt=""
        />

        <div className="copytrader-card__profile-info">
          <div className="copytrader-card__profile-name">{name}</div>
          <div className="copytrader-card__profile-long">{leverage}</div>
        </div>

        <div
          className={`copytrader-card__profile-star ${
            isStarred && "copytrader-card__profile-star--active"
          }`}
        >
          <StarIcon />
        </div>
      </div>

      <div className="copytrader-card__performance">
        <div className="copytrader-card__performance-info">
          <p className="copytrader-card__performance-text">
            Lead trader 90D PnL
          </p>
          <p className="copytrader-card__performance-pnl">{pnlPercent}</p>
          <p className="copytrader-card__performance-gas">{pnlValue}</p>
        </div>

        <div>
          <MarketCap {...marketCapData} />
        </div>
      </div>

      <div className="copytrader-card__stats">
        <div className="copytrader-card__stats-item">
          <p className="copytrader-card__stats-text">Copy traders</p>
          <p className="copytrader-card__stats-number">
            {copyTraders} / <span>{maxCopyTraders}</span>
          </p>
        </div>

        <div className="copytrader-card__stats-item">
          <p className="copytrader-card__stats-text">AUM</p>
          <p className="copytrader-card__stats-number">{aum}</p>
        </div>

        <div className="copytrader-card__stats-item">
          <p className="copytrader-card__stats-text">Days leading trades</p>
          <p className="copytrader-card__stats-number">{daysLeading}</p>
        </div>
      </div>

      <CopytradeButton onClick={handleCopyClick} disabled={isCardDisabled}>
        {isCardDisabled ? "Full" : "Copy"}
      </CopytradeButton>
    </NavLink>
  );
};
